import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { secondaryMarketPlaceNotificationApi, notifyOnProperty } from '../../services/MarketPlaceApi/secondaryMarket';
import { toastNotify } from '../../utils/toastNotify';
const initialState = {
  loading: false
};
export const notifyMeForSecondaryMarketPlace = createAsyncThunk('NOTIFY_MY_FOR_SECONDARY_MARKETPLACE', secondaryMarketPlaceNotificationApi);
export const notifyMeForProperty = createAsyncThunk('NOTIFY_ME_ON_PROPERTY', notifyOnProperty);

export const notifyMeSlice = createSlice({
  name: 'propertyDetails',
  initialState,
  extraReducers: {
    [notifyMeForSecondaryMarketPlace.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [notifyMeForSecondaryMarketPlace.fulfilled]: (state, action) => {
        toastNotify('notifyMe', action?.payload?.message);
        return {
            ...state,
            loading: false
        };
    },
    [notifyMeForSecondaryMarketPlace.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
      };
    },
    [notifyMeForProperty.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [notifyMeForProperty.fulfilled]: (state, action) => {
        toastNotify('notifyMe', action?.payload?.message);
        return {
            ...state,
            loading: false
        };
    },
    [notifyMeForProperty.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
      };
    },
  },
});
const { reducer } = notifyMeSlice;
export default reducer;